
















  import {Component, Vue, Watch} from 'vue-property-decorator';
import Navigation from '@/view/Navigation.vue';
import Router from 'vue-router'
import {mapGetters} from "vuex";
  import LoadingActions from "@/store/actions/loading";


Vue.use(Router);
@Component({
  components: {
    Navigation
  },
  computed: {
    ...mapGetters(['isLoading']),
  }
})
export default class App extends Vue {

  @Watch('$route')
  onPropertyChanged(to, from){
    this.$store.dispatch(LoadingActions.LOADING, false);
  }

}
